// numericOnly.js
const numericOnlyDirective = {
    // The directive's bind hook is called only once when the directive is first bound to an element.
    bind(el) {
      el.handler = (event) => {
        const input = event.target;
        const maxLength = input.getAttribute("maxlength");
        let newValue = String(input.value || "").replace(/\D/g, "");
        if (maxLength) {
          newValue = newValue.slice(0, Number(maxLength));
        }
        // Update the input value with the filtered value
        input.value = newValue;
        // Emit an input event to make sure the v-model is updated
        // event.target.dispatchEvent(new Event('input'));
      };
  
      // Attach the event listener for the input event
      el.addEventListener('input', el.handler);
    },
  
    // The directive's unbind hook is called when the directive is unbound from the element.
    unbind(el) {
      // Remove the event listener when the directive is unbound to prevent memory leaks.
      el.removeEventListener('input', el.handler);
    },
  };
  
  export default numericOnlyDirective;
